// extracted by mini-css-extract-plugin
export var brand = "_9j-9";
export var compact = "_9j-6";
export var extraSmall = "_9j-7";
export var icon = "_9j-0";
export var large = "_9j-4";
export var light = "_9j-1";
export var medium = "_9j-5";
export var outline = "_9j-b";
export var primaryDark = "_9j-a";
export var primaryLight = "_9j-8";
export var primaryModern = "_9j-c";
export var success = "_9j-2";
export var successSolid = "_9j-3";